<template>
  <div class="loading" />
</template>

<script></script>
<style>
.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid lightgray;
  border-radius: 50%;
  border-top-color: rgb(37, 138, 186);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
</style>
